import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  Spinner,
  CardImg,
  CardText,
} from "reactstrap";

// core components
import CardsHeader from "components/Headers/CardsHeader.js";
import axiosConfig from "consts/axiosConfig";
import { APP_IMAGE_URL } from "consts/Constants";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { normalizeDashboardResponse } from "./dashboardData";

function UserDashboard() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState({});
  const [announcements, setAnnouncements] = useState([]);
  const getReports = () => {
    axiosConfig
      .get("user/reports")
      .then((res) => {
        const dashboard = normalizeDashboardResponse(res.data);
        if (dashboard.next === "complete") {
          history.replace("/general/complete");
          return;
        }
        setReports(dashboard.reports);
        setAnnouncements(dashboard.announcements);
        setLoading(false);
      })
      .catch((error) => {
        setReports({});
        setAnnouncements([]);
        setLoading(false);
      });
  };
  useEffect(() => {
    getReports();
  }, []);
  const renderAnnounc = () => {
    return announcements.map((item) => {
      return (
        <Col md="12" xl="12">
          <div>
            <Card>
              {item.image ? (
                <CardImg alt="..." src={APP_IMAGE_URL + item.image} top />
              ) : (
                <></>
              )}

              <CardBody>
                <CardTitle className="h2 mb-0">{item.title}</CardTitle>
                <small className="text-muted">{item.short}</small>
                <br />
                <small className="text-muted">
                  Published: {moment(item.publish_date).fromNow()}
                </small>
                <CardText className="mt-4">
                  {item.body ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.body,
                      }}
                    ></div>
                  ) : (
                    <></>
                  )}
                </CardText>
              </CardBody>
            </Card>
          </div>
        </Col>
      );
    });
  };
  if (loading) {
    return (
      <div
        className="d-flex flex-column jc-center ai-center"
        style={{ height: 800 }}
      >
        <Spinner />
        <span className="text-muted mt-2">Loading...</span>
      </div>
    );
  }
  return (
    <>
      <CardsHeader name="" parentName="Dashboards" />
      <Container className="mt--6" fluid>
        <Row>
          <Col md="6" xl="3">
            <Card className="card-stats h-150">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0"
                    >
                      Total Contacts
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0">
                      {reports?.clients}
                    </span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                      <i className="ni ni-active-40" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="card-stats h-150">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0"
                    >
                      Your Network
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0">
                      {reports?.network}
                    </span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-gradient-orange text-white rounded-circle shadow">
                      <i className="ni ni-chart-pie-35" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="card-stats h-150">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0"
                    >
                      Number of Cases Referred In
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0">
                      {reports?.in}
                    </span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                      <i className="ni ni-money-coins" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="card-stats h-150">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0"
                    >
                      Number of Cases Referred out
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0">
                      {reports?.out}
                    </span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
                      <i className="ni ni-chart-bar-32" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {announcements.length ? (
          <Row className="mt-3 mb-4">
            <Col>
              <h1 className="text-center">Announcements</h1>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row>
          <div className="card-columns ann-columns">{renderAnnounc()}</div>
        </Row>
      </Container>
    </>
  );
}

export default UserDashboard;
